'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CLEAR_MODALS = 'clear-modals:command';

exports.CLEAR_MODALS = CLEAR_MODALS;
